<div [formGroup]="form">
  <!-- Non-inline -->
  <nz-form-item *ngIf="inline == false">
		<nz-form-label *ngIf="span != 0" [nzSpan]="span" [nzRequired]="wrapper.element.required">{{ wrapper.element.name }}</nz-form-label>
		<nz-form-label *ngIf="span == 0" [nzRequired]="wrapper.element.required">{{ wrapper.element.name }}</nz-form-label>

    <nz-form-control [nzAutoTips]="wrapper.autoTips">
      <nz-select
        [formControlName]="toControlKey(wrapper.element)"
        nzPlaceHolder="Search ICD-10..."
        nzShowSearch
        nzAllowClear
        nzServerSearch
        [nzDisabled]="readonly"
        [nzLoading]="isLoading"
        (nzOnSearch)="onSearch($event)"
      >
        <nz-option
          *ngFor="let opt of suggestions"
          [nzValue]="opt.id"
          [nzLabel]="getLabel(opt)"
          nzCustomContent
        >
          <div class="icd10-option">
            <div class="icd10-option__codes">
              <span class="icd10-option__code">{{ opt.icd_10_code }}</span>
              <span class="icd10-option__separator">·</span>
              <span class="icd10-option__sub-code">{{ opt.icd_10_3_code }}</span>
              <span class="icd10-option__separator">·</span>
              <span class="icd10-option__group">{{ opt.groupCode }}</span>
            </div>
            <div class="icd10-option__desc">{{ opt.whoFullDescription || opt.icd_10_3_code_desc }}</div>
            <div class="icd10-option__group-desc">{{ opt.groupDescription }}</div>
          </div>
        </nz-option>
      </nz-select>
    </nz-form-control>
  </nz-form-item>

  <!-- Inline -->
  <nz-form-item *ngIf="inline == true">
    <nz-form-control [nzAutoTips]="wrapper.autoTips">
      <nz-select
        [formControlName]="toControlKey(wrapper.element)"
        nzPlaceHolder="Search ICD-10..."
        nzShowSearch
        nzAllowClear
        nzServerSearch
        [nzDisabled]="readonly"
        [nzLoading]="isLoading"
        (nzOnSearch)="onSearch($event)"
      >
        <nz-option
          *ngFor="let opt of suggestions"
          [nzValue]="opt.id"
          [nzLabel]="getLabel(opt)"
          nzCustomContent
        >
          <div class="icd10-option">
            <div class="icd10-option__codes">
              <span class="icd10-option__code">{{ opt.icd_10_code }}</span>
              <span class="icd10-option__separator">·</span>
              <span class="icd10-option__sub-code">{{ opt.icd_10_3_code }}</span>
              <span class="icd10-option__separator">·</span>
              <span class="icd10-option__group">{{ opt.groupCode }}</span>
            </div>
            <div class="icd10-option__desc">{{ opt.whoFullDescription || opt.icd_10_3_code_desc }}</div>
            <div class="icd10-option__group-desc">{{ opt.groupDescription }}</div>
          </div>
        </nz-option>
      </nz-select>
    </nz-form-control>
  </nz-form-item>
</div>
